<script>
export default {
    name: 'vnodes',
    functional: true,
    props: {
        items: {
            type: [Object, Array]
        }
    },
    render: (h, ctx) => ctx.props.items
}
</script>
